import { mapState, mapActions } from 'vuex'
import { TIPO_GRUPO } from '../../util/constantes';

export default {
  data() {
    return {
      infiniteLoadingId: 0,
      validacao: {
        tipo: [{ required: true }],
        nome: [{ required: true }]
      },

      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    };
  },

  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "GRUPOS_CONTA"
          })[0];
      }
    }),
    ...mapState('tipoContasStore',{
      tipoConta(state) { return state.tipoContaSelecionado },
      tipoContaPesquisa(state) { return state.tipoContaPesquisa },
      listaTipoConta(state) { return state.listaTipoConta } ,
      labelQuantidade(state) { return state.labelQuantidade}
    }),

    tiposGrupo() {
      return TIPO_GRUPO;
    },
    
    exibirBotaoNovoTipoConta() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarTipoConta() {
      return (
        (this.tipoConta.id === 0 && this.permissoes.cadastro)
        || (this.tipoConta.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverGrupoConta() {
      return this.tipoConta.id !== 0 && this.permissoes.remocao;
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('tipoContasStore', [
      'listarTipoConta',
      'limparTipoContaListadas',
      'gravarTipoConta',
      'recuperarTipoConta',
      'removerTipoConta',
      'novoTipoConta',
      'limparTipoContaPesquisa'
    ]),

    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },

    limparPesquisaHandler() {
      this.limparTipoContaPesquisa();
    },

    novoHandler() {
      this.novoTipoConta();
      this.tabSelecionada = 'detalhes'
    },

    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },


    pesquisarHandler() {
      this.tipoContaPesquisa.pagina = 0;
      this.limparTipoContaListadas();
      this.infiniteLoadingId += 1;
    },

    pesquisar($state) {
      if(this.tipoContaPesquisa.pagina === 0) { this.showLoading(); }

      this.listarTipoConta(this.tipoContaPesquisa).then((resultado) => {
        if(this.tipoContaPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.tipoContaPesquisa.pagina +=1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.tipoContaPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.tipoContaPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error('Não foi possível conectar-se ao servidor')
      })
    },

    gravarHandler() {
      this.$refs['form'].validate(elFormValidationRules => {
        const formIsInvalid = !elFormValidationRules;
        if(formIsInvalid) {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          return;
        }

        this.gravar();
      })
    },

    gravar() {
      this.showLoading();

      this.gravarTipoConta(this.tipoConta).then(resultado => {
        if(resultado.status == 'SUCESSO') {
          this.$message.success(resultado.mensagem);
          this.listarTipoConta({});
        } else {
          this.$message.warning('Falha ao gravar tipo de conta')
        }
      }).catch(() => {
        this.$message.error('Não foi possível conectar-se ao servidor')
      }).finally(() => {
        this.hideLoading();
      })
    },

    recuperarHandler(tipoConta) {
      this.recuperar(tipoConta);
    },

    recuperar(tipoConta) {
      this.showLoading();
      this.recuperarTipoConta(tipoConta)
      .then(() => {
      }).catch(() => {
        this.$message.error('Não foi possível conectar-se com o servidor.')
      }).finally(() => {
        this.hideLoading();
      })
    },

    removerHandler() {
      this.$confirm('Deseja realmente remover este Tipo de conta?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(() => {
        this.remover();
      });
    },

    remover() {
      this.showLoading();

      this.removerTipoConta(this.tipoConta).then((resultado) => {
        if(resultado.status == 'SUCESSO') {
          this.listarTipoConta({});
          this.novoTipoConta();
          this.$message.success(resultado.mensagem);
        } else if(resultado.status == 'ERRO') {
          this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error('Não foi possível conectar-se com o servidor.')
      }).finally(() => {
        this.hideLoading();
      });
    }
  },
}